// owned by WP-SEC-UI · English strings of the sign-in card (security §14; shared `auth.*` stays in packages/i18n common).
// Key path `econic.auth.*`; deep-merged by ./index.en.ts with every other area (a duplicate leaf key throws in development).
const authEn = {
  econic: {
    auth: {
      title: "Sign in to ECONIC",
      email: "Email",
      signIn: "Sign in",
      forgot: "Forgot password?",
      ministryOnly: "ECONIC is the Ministry's internal service: sign in with your Ministry account.",
      forgotHint: "Your administrator resets it.",
      setup: {
        title: "Choose a new password",
        sub: "It replaces the temporary password.",
        new: "New password",
        confirm: "Confirm password",
        submit: "Continue",
        rules: {
          length: "14+ characters",
          noName: "No name or email",
          notReused: "Not a recent password",
          notBreached: "Not a leaked password",
          match: "Both entries match",
        },
        reenrol: "Your authenticator was reset. Scan the new code to finish signing in.",
        rulesMet: "Password rules met",
      },
      /** Why the person is on the sign-in page: one short line above the form. */
      reason: {
        idle: "Signed out after 30 minutes idle.",
        expired: "Session ended after 10 hours.",
        revoked: "Session ended by an administrator or another device.",
        ended: "Session ended.",
        other_tab: "Signed out in another tab.",
      },
      signingIn: "Signed in",
      account: "Account",
    },
  },
};

export default authEn;
